





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CollectionNames } from '../services/meiosis';

@Component({
  components: {},
})
export default class EditComponentCard extends Vue {
  @Prop({ default: '' }) public itemkey!: CollectionNames;
  @Prop({ default: '' }) public itemname!: string;
  @Prop({ default: '' }) public itemdesc!: string;
  @Prop({ default: '' }) public itemid!: string;
  @Prop({ default: false }) public lockName!: boolean;
  private newName = '';
  private desc = '';
  constructor() {
    super();
  }

  private getTranslateKey() {
    return this.$tc(`COMP.${this.itemkey.toUpperCase()}`);
  }

  private editItem() {
    this.$store.actions[this.itemkey].save({ id: this.itemid, name: this.newName, desc: this.desc });
    this.$store.actions[this.itemkey].load(this.itemid);
    this.$emit('close');
  }

  private deleteItem() {
    this.$store.actions[this.itemkey].del(this.itemid);
    this.$emit('close');
  }

  private async cancel() {
    this.$emit('close');
  }

  mounted(): void {
    this.newName = this.itemname;
    this.desc = this.itemdesc;
  }
}
